import { FormattedMessage } from "react-intl";

export const JoinableSitesText = () => (
    <FormattedMessage
        id="signup.siteActivation.joinableSites.subheader"
        defaultMessage="Select where you’d like to get started."
    />
);
